import http from './http'
import { getToken } from './auth'

const base = 'Users'

export async function getSelf() {
    const { data } = await http.get(`${base}/self`, {
        headers: {
            'Authorization': 'Bearer ' + getToken()
        }
    })
    return data
}

export async function login(account) {
    return await http.post(base + '/login', account)
}

export async function register(payload) {
    const config = {
        headers: {
            'Content-Type': 'application/json',
        }
    }

    const { data } = await http.post(base + '/register', payload, config)
    return data
}

export async function resendVerification(email) {
    const { data } = await http.post(base + '/resend-verification', { email }, {
        headers: { 'Content-Type': 'application/json' }
    })
    return data
}

export async function verifyEmail(token) {
    const { data } = await http.post(base + '/verify-email', { token }, {
        headers: { 'Content-Type': 'application/json' }
    })
    return data
}

export async function forgotPassword(email) {
    const { data } = await http.post(base + '/forgot-password', { email }, {
        headers: { 'Content-Type': 'application/json' }
    })
    return data
}

export async function resetPassword(token, password) {
    const { data } = await http.post(base + '/reset-password', { token, password }, {
        headers: { 'Content-Type': 'application/json' }
    })
    return data
}

// Invitation acceptance: the token from the e-mailed /accept-invite/<token> link.
export async function acceptInvite(token, password) {
    const { data } = await http.post(base + '/accept-invite', { token, password }, {
        headers: { 'Content-Type': 'application/json' }
    })
    return data
}

export async function updateUser(payload) {
    const config = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + getToken(),
        }
    }

    const { data } = await http.patch(base + '/' + payload.id, payload, config)
    return data
}

export async function updateProfile(payload) {
    const config = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + getToken(),
        }
    }

    const { data } = await http.patch(base + '/self', payload, config)
    return data
}

export async function deleteUser(id) {
    const config = {
        headers: {
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + getToken(),
        }
    }

    const { data } = await http.delete(base + '/' + id, config)
    return data
}